import { SET_SWITCH_TAB  } from "../actions/SwitchTabAction";

const initialState = {
  isSwitch: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_SWITCH_TAB:
      return {
        ...state,
        isSwitch: action.payload,
      };
   
    default:
      return state;
  }
};